import { getApprovedSummary, getRegisterVerificationSummary, getValidationReasonLabel, getValidationState } from '@/lib/validation'
import type { Customer } from '@/api/types'

const bannerBaseClass = 'border px-4 py-3 text-sm sm:col-span-2'
const warningClass = 'border-amber-200 bg-amber-50 text-amber-800'
const verifiedClass = 'border-emerald-200 bg-emerald-50 text-emerald-700'
const waitingClass = 'border-border bg-muted text-muted-foreground'

const NEEDS_REVIEW_HINT = 'Godkänn uppgifterna eller rätta dem. Inga leveranser bokas förrän kunden är verifierad.'
const WAITING_LABEL = 'Väntar på kontroll mot folkbokföringen'
const CORRECTION_HINT = 'Ändringarna står i anteckningarna längre ner.'

export function CustomerValidationBanner({ customer }: { customer: Customer }): React.ReactElement | null {
  const state = getValidationState(customer)

  if (state === 'needs_review') {
    return (
      <div className={`${bannerBaseClass} ${warningClass}`}>
        <p className="font-medium">Behöver kontroll — {getValidationReasonLabel(customer.validation_reason)}</p>
        <p className="mt-1 text-xs">{NEEDS_REVIEW_HINT}</p>
      </div>
    )
  }

  if (state === 'waiting') {
    return (
      <div className={`${bannerBaseClass} ${waitingClass}`}>
        <p className="font-medium">{WAITING_LABEL}</p>
      </div>
    )
  }

  if (state === 'approved') {
    return (
      <div className={`${bannerBaseClass} ${verifiedClass}`}>
        <p className="font-medium">{getApprovedSummary(customer)}</p>
      </div>
    )
  }

  if (state === 'corrected') {
    return (
      <div className={`${bannerBaseClass} ${verifiedClass}`}>
        <p className="font-medium">{getRegisterVerificationSummary(customer)}</p>
        <p className="mt-1 text-xs">{CORRECTION_HINT}</p>
      </div>
    )
  }

  if (state === 'confirmed') {
    return (
      <div className={`${bannerBaseClass} ${verifiedClass}`}>
        <p className="font-medium">{getRegisterVerificationSummary(customer)}</p>
      </div>
    )
  }

  return null
}
